import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e37db180")

_pushScopeId("data-v-e37db180")
const _hoisted_1 = { class: "pay_settings" }
const _hoisted_2 = { class: "timeopts_ul" }
const _hoisted_3 = {
  key: 0,
  class: "tit pay_title_label"
}
const _hoisted_4 = {
  key: 1,
  class: "tit_img"
}
const _hoisted_5 = {
  key: 2,
  class: "tit_time_limit"
}
const _hoisted_6 = { class: "time_limit pay_counter" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "limit_title" }, [
  /*#__PURE__*/_createTextVNode("限时"),
  /*#__PURE__*/_createVNode("em", { class: "time_em" }, ":")
], -1)
const _hoisted_8 = { class: "time_span" }
const _hoisted_9 = /*#__PURE__*/_createVNode("em", { class: "time_em" }, ":", -1)
const _hoisted_10 = { class: "time_span" }
const _hoisted_11 = /*#__PURE__*/_createVNode("em", { class: "time_em" }, ":", -1)
const _hoisted_12 = { class: "time_span" }
const _hoisted_13 = { class: "price flex_centers" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("￥")
const _hoisted_16 = { class: "tip" }
const _hoisted_17 = {
  key: 3,
  class: "diamond_privilege"
}
const _hoisted_18 = { class: "renew_box" }
const _hoisted_19 = {
  key: 0,
  class: "renew"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "到期自动续费 ", -1)
const _hoisted_21 = {
  key: 1,
  class: "renew"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "timeopts_overflow",
      style: { paddingTop: _ctx.settingPaddingNums + 'px' }
    }, [
      _createVNode("ul", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paySetting, (item, idx) => {
          return (_openBlock(), _createBlock("li", {
            key: idx,
            class: [{ active: _ctx.viewModel.payIdx === idx }, "timeopts_li"],
            style: { width: _ctx.payItemClass.outer + 'px !important' },
            onClick: ($event: any) => (_ctx.switchPaySettingItem(idx)),
            onMouseenter: ($event: any) => (_ctx.isDiamondHoverTip(item, idx)),
            onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewModel.showDiamondTip = false))
          }, [
            (item?.page_detail.title_type === 1)
              ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(item?.page_detail.title), 1))
              : (item?.page_detail.title_type === 2)
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    _createVNode("img", {
                      src: item?.page_detail.title_img
                    }, null, 8, ["src"])
                  ]))
                : (_ctx.isCountdown(item?.page_detail))
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _createVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode("span", _hoisted_8, _toDisplayString(_ctx.viewModel.coutTimeNum.h), 1),
                        _hoisted_9,
                        _createVNode("span", _hoisted_10, _toDisplayString(_ctx.viewModel.coutTimeNum.m), 1),
                        _hoisted_11,
                        _createVNode("span", _hoisted_12, _toDisplayString(_ctx.viewModel.coutTimeNum.s), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
            _createVNode("div", {
              style: { width: _ctx.payItemClass.inner + 'px !important' },
              class: "timeopts_content"
            }, [
              _createVNode("div", _hoisted_13, [
                _createVNode("span", null, "￥" + _toDisplayString(item?.page_detail.current_fee), 1),
                (_ctx.viewModel.currentTabType === 'super')
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      (item.page_detail.center_fee)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _hoisted_15
                          ], 64))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(item.page_detail.center_fee), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_16, _toDisplayString(item?.page_detail.discount_desc), 1)
            ], 4),
            _createVNode("div", {
              class: ["timeopts_litips", { del: item?.page_detail.bottom_type === 2 }]
            }, _toDisplayString(item?.page_detail.bottom), 3),
            (_ctx.viewModel.showDiamondTip && _ctx.viewModel.hoverIdx === idx)
              ? (_openBlock(), _createBlock("div", _hoisted_17))
              : _createCommentVNode("", true)
          ], 46, ["onClick", "onMouseenter"]))
        }), 128))
      ])
    ], 4),
    _createVNode("div", _hoisted_18, [
      false
        ? (_openBlock(), _createBlock("div", _hoisted_19, [
            _createVNode("span", {
              class: [{ checkbox_sel: _ctx.viewModel.renew }, "checkbox"],
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeRenew && _ctx.changeRenew(...args)))
            }, null, 2),
            _hoisted_20,
            _createVNode("a", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openXieYi && _ctx.openXieYi(...args)))
            }, "《自动续费服务协议》")
          ]))
        : (_ctx.showStatusDesc('diamond'))
          ? (_openBlock(), _createBlock("div", _hoisted_21, "钻石会员，不限时享受高级特权！"))
          : _createCommentVNode("", true)
    ])
  ]))
})